import React, { useRef, useEffect } from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

const MORE_OPTIONS = [
    { name: "Media", label: "Media" },
    // { name: "Settings", label: "Settings" },
    { name: "ServiceConfig", label: "Service configuration" },
];

const VehicleViewTabs = ({
    TABS,
    activeTab,
    isMoreOpen,
    setIsMoreOpen,
    handleTabClick,
    handleMoreClick,
    handleMoreOptionClick,
    isMoreActive
}) => {
    const moreButtonRef = useRef(null);
    const tabsContainerRef = useRef(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                moreButtonRef.current &&
                !moreButtonRef.current.contains(event.target) &&
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsMoreOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [setIsMoreOpen]);

    const getDropdownPosition = () => {
        if (!moreButtonRef.current || !tabsContainerRef.current) return { left: 0 };

        const buttonRect = moreButtonRef.current.getBoundingClientRect();
        const containerRect = tabsContainerRef.current.getBoundingClientRect();
        const viewportWidth = window.innerWidth;

        let left = buttonRect.left - containerRect.left;
        const dropdownWidth = 100;
        const rightEdge = buttonRect.left + dropdownWidth;

        if (rightEdge > viewportWidth) {
            left = left - (dropdownWidth - buttonRect.width);
        }

        return { left };
    };

    return (
        <div className={`mt-4 border-b border-gray-200`}>
            <div className="relative">
                <nav
                    className="flex overflow-x-auto gap-4 no-scrollbar"
                    ref={tabsContainerRef}
                    style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                >
                    {TABS.filter((tab) => !MORE_OPTIONS.map((opt) => opt.name).includes(tab.name)).map((tab) => (
                        <div key={tab.name} className="relative flex-shrink-0">
                            <button
                                ref={tab.name === "More" ? moreButtonRef : null}
                                onClick={tab.name === "More" ? handleMoreClick : () => handleTabClick(tab.name)}
                                className={`flex items-center justify-between px-1 text-left py-2 text-sm border-r border-gray-200 last:border-r-0 ${activeTab === tab.name || (tab.name === "More" && isMoreActive)
                                    ? "border-b-2 border-purple-600 text-purple-600 font-medium"
                                    : "text-gray-600 hover:text-gray-900"
                                    }`}
                            >
                                {tab.name}
                                {tab.name === "More" && (
                                    <ChevronDownIcon
                                        className={`h-4 w-4 ml-1 transition-transform duration-200 ${isMoreOpen || isMoreActive ? "transform rotate-180"
                                            : ""
                                            }`}
                                    />
                                )}
                            </button>
                        </div>
                    ))}
                </nav>
                {isMoreOpen && (
                    <div ref={dropdownRef} className="absolute top-full z-50" style={getDropdownPosition()}>
                        <div className="min-w-[100px] bg-white border border-gray-200 shadow-lg rounded-md mt-1">
                            {MORE_OPTIONS.map((option) => (
                                <button
                                    key={option.name}
                                    onClick={() => handleMoreOptionClick(option.name)}
                                    className={`block w-full text-left px-4 py-2 text-sm ${activeTab === option.name ? "text-purple-600 font-medium bg-purple-50" : "text-gray-700 hover:bg-gray-100"
                                        }`}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VehicleViewTabs; 